import { css } from 'styled-components';
import { FontLineHeightTight } from 'autogen/design-tokens/global/tokens';

const TitleStyling = css`
    font-family: ${({ theme }) => theme.TypographyFamilyPrimary};
    font-weight: ${({ theme }) => theme.TypographyTitleWeight};
    line-height: ${FontLineHeightTight};
`;

export default TitleStyling;
